import { CONSOLE_PATHS } from "@sagot/constants";
import type { ReactElement } from "react";
import { RequirePermission } from "../pages/forbidden-page";
import { AnalyticsPage } from "./engage/analytics/analytics-page";
import { AnnouncementsPage } from "./engage/announcements/announcements-page";
import { GapsPage } from "./engage/gaps/gaps-page";
import { InboxPage } from "./engage/inbox/inbox-page";
import { LeadsPage } from "./engage/leads/leads-page";
import { WallboardPage } from "./engage/wallboard/wallboard-page";
import { WorkflowPage } from "./engage/workflows/workflow-page";
import { WorkflowsPage } from "./engage/workflows/workflows-page";

/** Screens owned by the "engage" feature group, keyed by CONSOLE_PATHS value. */
export const engageScreens: Readonly<Record<string, ReactElement>> = {
  [CONSOLE_PATHS.inbox]: (
    <RequirePermission permission="inbox.view">
      <InboxPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.gaps]: (
    <RequirePermission permission="gaps.view">
      <GapsPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.leads]: (
    <RequirePermission permission="leads.view">
      <LeadsPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.workflows]: (
    <RequirePermission permission="workflows.view">
      <WorkflowsPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.workflow]: (
    <RequirePermission permission="workflows.view">
      <WorkflowPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.announcements]: (
    <RequirePermission permission="announcements.view">
      <AnnouncementsPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.analytics]: (
    <RequirePermission permission="analytics.view">
      <AnalyticsPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.wallboard]: (
    <RequirePermission permission="wallboard.view">
      <WallboardPage />
    </RequirePermission>
  ),
};
